import { FULFILLMENT_TYPES } from '../constants';
/**
 * @private
 * @description encompasses business logic for determining the fulfillment type
 * @param {object} parameters - named parameters
 * @property {FulfillmentOfferingItem} item - a singular item amongst array of item args from consumer
 * @returns {string|null} either a fulfillmentType as string or null
 */

export default function determineFulfillmentType(_ref) {
  var item = _ref.item;
  if (item.fulfillmentType) return item.fulfillmentType;
  if (item.giftCard && item.shippingMethod === 'DIGITAL_GIFTCARD') return FULFILLMENT_TYPES.digital;
  return null;
}